/* eslint-disable import/prefer-default-export */

/**
 * Given a data path (e.g. "path.to.agent"), returns a formatter function
 * that, when given an Immutable Map, will check for an entity at the data path
 * and return a formatted first and last name.
 */
export const getFullNameFormatterAtDataPath = (nameHaverDataPath) => (item) => {
  const nameHaver = item.getIn(nameHaverDataPath.split('.'));

  if (nameHaver) {
    const firstName = nameHaver.get('firstName') || '';
    const lastName = nameHaver.get('lastName') || '';

    return `${firstName} ${lastName}`;
  }

  return null;
};
